import { render } from "./ModalEditDialog.vue?vue&type=template&id=42a2eb6b"
import script from "./ModalEditDialog.vue?vue&type=script&lang=js"
export * from "./ModalEditDialog.vue?vue&type=script&lang=js"

import "./ModalEditDialog.vue?vue&type=style&index=0&id=42a2eb6b&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "42a2eb6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42a2eb6b', script)) {
    api.reload('42a2eb6b', script)
  }
  
  module.hot.accept("./ModalEditDialog.vue?vue&type=template&id=42a2eb6b", () => {
    api.rerender('42a2eb6b', render)
  })

}

script.__file = "src/components/roster/ModalEditDialog.vue"

export default script